import CIcon from '@coreui/icons-react';
import { CBadge } from '@coreui/react';
import React from 'react';
import PropTypes from 'prop-types';

const TooltipTag = ({ name, description, type, className }) => {
     const badgeTypeData = {
          info: 'bg-info',
          primary: 'bg-primary',
          success: 'bg-success',
          secondary: 'bg-secondary',
          danger: 'bg-danger',
          light: 'bg-light',
     };
     const badgeType = badgeTypeData[type];

     return (
          <>
               {badgeType && (
                    <div className={`tooltip-tag ${className || ''}`}>
                         <CBadge className={badgeType}>{name}</CBadge>
                         {description && (
                              <div className="block-tooltip-tag">
                                   <CIcon icon="arrowTooltip" className="icon-arrow-area" />
                                   <div className="block-tooltip-text">
                                        <p>{description}</p>
                                   </div>
                              </div>
                         )}
                    </div>
               )}
          </>
     );
};


TooltipTag.propTypes = {
     name: PropTypes.string,
     type: PropTypes.string,
     description: PropTypes.string,
     className: PropTypes.string,
};

export default TooltipTag;
